import {colors} from "vuetify/lib";

export class TagInfo {
  constructor(title, color, tooltip) {
    this.title = title;
    this.color = color;
    this.tooltip = tooltip;
  }
}

export default {
  data: (vm) => {
    return {
      tagBooked: new TagInfo(vm.$t("tagInfo.booked"), colors["green"]["base"]),
      tagPayed: new TagInfo(vm.$t("tagInfo.payed"), colors["green"]["base"]),
      tagReserved: new TagInfo(vm.$t("tagInfo.reserved"), colors["green"]["base"]),
      tagNeedMore: new TagInfo(vm.$t("tagInfo.needMore"), colors["red"]["lighten2"]),
      tagBookedOut: new TagInfo(vm.$t("tagInfo.bookedOut"), colors["red"]["lighten1"]),
      tagFewPlaces: new TagInfo(vm.$t("tagInfo.fewPlaces"), colors["orange"]["lighten1"]),
      tagPlacesAvail: new TagInfo(vm.$t("tagInfo.placesAvail"), colors["green"]["lighten2"]),
      tagPlaceHolder: new TagInfo(" | ", colors["shades"]["transparent"]),
    };
  },

  methods: {
    getCourseTags(course) {
      var tagsToDisplay = [];

      var minMembers = course.MinMemberNumber;
      var maxMembers = course.MaxMemberNumber;
      var currentMembers = course.MemberNumber;

      if (maxMembers > 0) {
        if (currentMembers == maxMembers) tagsToDisplay.push(this.tagBookedOut);
        
        // the tag 'wenige freie Plätze' is displayed if < 15% of the places are available (and of course there must still be free places in the course)
        // calculate the "free places" percentage 
        const percentFree = 100 - ((currentMembers / maxMembers) * 100);
        
        if (percentFree <= 15 && maxMembers - currentMembers > 0) {
          tagsToDisplay.push(this.tagFewPlaces);
        } else if (percentFree > 15) {
          tagsToDisplay.push(this.tagPlacesAvail);
        }
      }

      if (minMembers > 0) {
        if (currentMembers < minMembers) tagsToDisplay.push(this.tagNeedMore);
      }

      if (minMembers == 0 && maxMembers == 0) {
        tagsToDisplay.push(this.tagPlacesAvail);
      }

      return tagsToDisplay;
    },

    getHallTags(hall) {
      var tagsToDisplay = [];
      var tagColors = Object.values(colors);
      var tagColorIndex = 0;

      for (var index in hall.TypesOfUse) {
        tagsToDisplay.push(new TagInfo(hall.TypesOfUse[tagColorIndex], tagColors[tagColorIndex].base));
        // tagColors[19] only contains white, black and 'transparent' - we dont need them
        if (tagColorIndex == tagColors.length - 2) {
          tagColorIndex = 0;
          continue;
        }

        tagColorIndex++;
      }

      return tagsToDisplay;
    },

    getHallBookedAndPayedTags(hall) {
      var timesBooked = hall.BookedDates.filter(bookedDate => bookedDate.IsPayed == false).length;
      var timesPayed = hall.BookedDates.filter(bookedDate => bookedDate.IsPayed == true).length;
      

      var tagsToDisplay = [];

      if (timesBooked > 0)
        tagsToDisplay.push(new TagInfo(this.$t('tagInfo.timesBooked', [timesBooked]), colors["green"]["base"]));

      if (timesPayed > 0)
        tagsToDisplay.push(new TagInfo(this.$t('tagInfo.timesPayed', [timesPayed]), colors["green"]["base"]));

      return tagsToDisplay;
    }
  },
};
